<template>
  <div class="secondary-skills">
    <div class="panel-title h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="label">英雄技能</div>
      <div class="tools">
        <div class="btn h-title nowrap" data-title="将所有属性点设为最大值" v-click-sound-button @click="handleFillMax">点满</div>
        <div class="btn h-title nowrap" data-title="将所有属性点设为 0" v-click-sound-button @click="handleFillMin">清空</div>
      </div>
      <div class="info">
        技能点数：{{ totalPoint }}
      </div>
    </div>

    <div class="secondary-skills-box h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="item h-outer-border around-4 bw2 bz0 h-title"
           :class="[`level-${item.level}`]"
           :data-title="item.desc[Math.max(0, item.level - 1)]"
           v-for="item in config">
        <img :src="skillIconUrl(item.sourceName, item.level)" alt="">
        <div class="skill-info h-outer-border around-4 bw2 bz0">
          <div class="mini-btn minus"
               v-click-sound-button
               :disabled="item.level <= 0"
               @click="handleMinusSSP(item)">-
          </div>
          <div class="skill-level white">
            {{ levelName[item.level] }}
          </div>
          <div class="mini-btn plus"
               v-click-sound-button
               :disabled="item.level >= 3"
               @click="handleAddSSP(item)">+
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import secondarySkillsConfig from '@js/config/resource/secondary-skills-config'

  const filteredSecondarySkillsConfig = secondarySkillsConfig.filter((item) => item.name !== 'Necromancy')

  export default {
    name: 'SecondarySkills',

    data () {
      return {
        loading: false,
        config: [],
        levelName: {
          0: '无',
          1: '初级',
          2: '中级',
          3: '高级',
        }
      }
    },

    props: {
      initSecondarySkills: {
        type: Array,
        default () {
          return null
        }
      },
    },

    computed: {
      ...mapGetters('hero', []),

      totalPoint () {
        return this.config.map(d => d.level).reduce((a, b) => {
          return a + b
        }, 0)
      }
    },

    watch: {
      initSecondarySkills (val) {
        if (val) {
          const skills = val.map((v) => {
            const name = Object.keys(v)[0]
            const level = v[name]
            return { name, level }
          })
          this.config = filteredSecondarySkillsConfig.map((d) => {
            const level = skills.find((s) => d.name === s.name)?.level
            return { ...d, level: level || 0 }
          })
        }
      }
    },

    mounted () {
      this.config = filteredSecondarySkillsConfig.map((d) => {
        return { ...d, level: 0 }
      })
    },

    methods: {
      getSkillLevel (name) {
        return +this.config[name] || 0
      },

      getFormData () {
        return JSON.parse(JSON.stringify(this.config))
      },

      handleFillMin () {
        this.config.forEach((item) => {
          item.level = 0
        })
      },
      handleFillMax () {
        this.config.forEach((item) => {
          item.level = 3
        })
      },

      skillIconUrl (name, level) {
        const sourceName = name + (['A', 'A', 'B', 'C'][level] || '')
        return `${this.$rHost}/img/common/secondary_skill/${sourceName}.jpg`
      },

      async handleMinusSSP (item) {
        item.level = Math.min(Math.max(item.level - 1, 0), 3)
      },

      async handleAddSSP (item) {
        item.level = Math.min(Math.max(item.level + 1, 0), 3)
      },
    }
  }
</script>

<style lang="stylus" scoped>
  .panel-title
    display flex
    align-items center
    margin-bottom 1px
    padding 2px 7px
    line-height 24px
    font-size 12px
    whiteText1()
    .label
      flex-grow 1
      letter-spacing 1px
      goldText()
    .info
      width 82px
      text-align right
      &:after
        width 150px

  .secondary-skills-box
    margin-top 3px
    display flex
    flex-wrap wrap
    padding 2px
    .item
      position relative
      margin 3px
      width 71px
      height 104px
      padding 2px
      user-select none
      > img
        box-sizing border-box
        width 67px
        height 76px
        vertical-align top
      &:after
        width 175px
      &:nth-child(8):after
        width 175px
        right 0
        left auto
        transform translate(0, -100%)
      &:hover
        outline 1px solid $colorGold
        .skill-info .mini-btn
          opacity 1
        &.level-0
          > img
            opacity .8
      &.level-0
        > img
          opacity .6
          filter grayscale(1)
        .skill-info .skill-level
          opacity .5

  .skill-info
    display flex
    margin-top 1px
    padding 2px
    .skill-level
      flex-grow 1
      line-height 18px
      font-size 12px
      text-align center
      letter-spacing 1px
      transform-origin center
    .mini-btn
      opacity 0
      position relative
      goldText1()
      width 18px
      height 18px
      font-size 14px
      border 1px solid #78624a
      border-radius 2px
      line-height 16px
      text-align center
      background-color #392519
      cursor pointer
      user-select none
      &.minus
        line-height 14px
      &:hover
        cursor pointer
        border-color lighten(#78624a, 10%)
        color darken($colorGold, 30%)
    .mini-btn[disabled]
      filter grayscale(1)
      cursor not-allowed

  .tools
    position relative
    padding 0 10px
    display flex
    .btn
      padding 0 2px
      line-height 24px
      letter-spacing 1px
      user-select none
      color $colorGold
      opacity 0.75
      &:not(:last-child)
        margin-right 5px
      &:hover
        opacity 1
        color $colorGold
        cursor pointer
      &:active
        opacity 1
        color darken($colorGold, 15%)
</style>
